var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md12: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "v-form",
                    { staticClass: "col-md-12" },
                    [
                      _c("StepTitle", [
                        _vm._v(
                          "\n            Servicio de Descargas, Proveedores o Clientes Proveedor\n          "
                        )
                      ]),
                      _c("v-divider"),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "", lg12: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "" },
                                  model: {
                                    value: _vm.tipoAsociacion,
                                    callback: function($$v) {
                                      _vm.tipoAsociacion = $$v
                                    },
                                    expression: "tipoAsociacion"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Servicio de Descarga",
                                      value:
                                        _vm.tiposAsociacion.serviciodescarga
                                    }
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Proveedor",
                                      value: _vm.tiposAsociacion.proveedor,
                                      disabled:
                                        _vm.seleccionadosDescargas.length > 0
                                    }
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Cliente Proveedor",
                                      value:
                                        _vm.tiposAsociacion.clientesproveedor,
                                      disabled:
                                        _vm.seleccionadosDescargas.length > 0
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("AsociarServicioDescarga", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.tipoAsociacion ===
                                  _vm.tiposAsociacion.serviciodescarga,
                                expression:
                                  "tipoAsociacion === tiposAsociacion.serviciodescarga"
                              }
                            ],
                            attrs: {
                              "test-id": "AsociarServicioDescarga",
                              listadoDescargas: _vm.listadoDescargas,
                              infoDescargasAsignados: [],
                              readonly: _vm.readonly,
                              esEditar: _vm.esEditar,
                              show:
                                _vm.tipoAsociacion ===
                                _vm.tiposAsociacion.serviciodescarga,
                              esInformeProgramado: false
                            },
                            on: { selectionChange: _vm.selectionChangeDescarga }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("AsociarProveedor", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.tipoAsociacion ===
                                  _vm.tiposAsociacion.proveedor,
                                expression:
                                  "tipoAsociacion === tiposAsociacion.proveedor"
                              }
                            ],
                            attrs: {
                              "test-id": "AsociarProveedor",
                              listadoProveedor: _vm.listadoProveedor,
                              infoProveedorAsignados: [],
                              readonly: _vm.readonly,
                              esEditar: _vm.esEditar,
                              show:
                                _vm.tipoAsociacion ===
                                _vm.tiposAsociacion.proveedor,
                              esInformeProgramado: false
                            },
                            on: {
                              selectionChange: _vm.selectionChangeProveedor
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("AsociarClientesProveedor", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.tipoAsociacion ===
                                  _vm.tiposAsociacion.clientesproveedor,
                                expression:
                                  "tipoAsociacion === tiposAsociacion.clientesproveedor"
                              }
                            ],
                            attrs: {
                              "test-id": "AsociarClientesProveedor",
                              listadoClientesProveedor:
                                _vm.listadoClientesProveedor,
                              infoClientesProveedorAsignados: [],
                              readonly: _vm.readonly,
                              esEditar: _vm.esEditar,
                              show:
                                _vm.tipoAsociacion ===
                                _vm.tiposAsociacion.clientesproveedor,
                              esInformeProgramado: false
                            },
                            on: {
                              selectionChange:
                                _vm.selectionChangeClientesProveedor
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }